
export default {
    getDeficiencia(state) {
        return state.deficiencia
    },
    getDeficiencias(state) {
        return state.deficiencias
    },
}